import { Box, Tab, Tabs, Typography } from "@mui/material";
import { useState } from "react";

export default function SolutionsTabs({ solutions }: any) {
  const [value, setValue] = useState<number>(0);

  const handleChange = (_event: any, newValue: any) => {
    setValue(newValue);
  };

  const decodeBase64 = (str: string) => atob(str);

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs value={value} onChange={handleChange} variant="scrollable">
        {solutions?.map((sol: any, index: any) => (
          <Tab
            key={sol.id}
            label={sol.language.name}
            id={`tab-${index}`}
            aria-controls={`tabpanel-${index}`}
          />
        ))}
      </Tabs>
      {solutions?.map((sol: any, index: any) => (
        <TabPanel key={sol?.id} value={value} index={index}>
          <Typography variant="h6">{sol?.language?.name} Solution</Typography>
          <div className="admin-panel-modal-code-horizontal-wrapper">
            <div className="admin-panel-modal-code-wrapper">
              <Typography
                variant="body2"
                sx={{ mt: 1, fontWeight: "bold", color: "#f4f4f4" }}
              >
                Code:
              </Typography>
              <pre className="admin-panel-modal-code-text">
                {decodeBase64(sol?.solution)}
              </pre>
            </div>
            <div className="admin-panel-modal-predefined-code-wrapper">
              <Typography
                variant="body2"
                sx={{ mt: 2, fontWeight: "bold", color: "#f4f4f4" }}
              >
                Predefined Code:
              </Typography>
              <pre
                style={{
                  background: "#f5f5f5",
                  padding: "10px",
                  borderRadius: "6px",
                  overflow: "auto",
                  height: "200px",
                }}
              >
                {decodeBase64(sol?.predefined_code)}
              </pre>
            </div>
          </div>
        </TabPanel>
      ))}
    </Box>
  );
}

function TabPanel({ children, value, index }: any) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}
